<template>
  <div class="ui stackable grid">
    <div class="ten wide column">
      <div class="ui segment" v-if="isHost">
        <h2 class="ui header">{{ activeQuestion.question }}</h2>
      </div>
      <keyword-panel
        :keywords="keywords"
        @clickedKeyword="markKeyword"
      ></keyword-panel>
    </div>
    <div class="six wide column">
      <scoreboard-vertical></scoreboard-vertical>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ScoreboardVertical from '@/components/elements/scoreboardVertical';
import KeywordPanel from '@/components/elements/keywordPanel';

export default {
  name: 'play-screen',
  components: { ScoreboardVertical, KeywordPanel },
  computed: {
    ...mapGetters(['isHost']),
    ...mapGetters('collectiefGeheugen', ['activeQuestion']),
    keywords() {
      return this.$store.getters['collectiefGeheugen/activeKeywords'];
    }
  },
  methods: {
    markKeyword(keywordId) {
      this.$store.dispatch('collectiefGeheugen/answerQuestion', keywordId);
      this.$store.dispatch('syncGame');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
